'use strict';
const i18n = require('i18next');
const Mn = require('backbone.marionette');
const Key = require('common/domain/value/key');
const GroupAction = require('common/domain/action/group');
const GroupRepository = require('common/domain/repository/group');
const ModalView = require('common/ui/view/modal/index');
const DiagramAction = require('system/domain/action/diagram');
const DiagramRepository = require('system/domain/repository/diagram');
const DiagramModel = require('system/domain/entity/diagram');
const DiagramEditView = require('system/ui/view/modal/diagram-edit');
const ImportableDiagramListService = require('balus/app/service/diagram/list-importable');
const ImportableDiagramService = require('balus/app/service/diagram/import');
const DiagramDirectoryEditView = require('system/ui/view/modal/diagram-directory-edit');
const DiagramListView = require('system/ui/view/diagram/list');
const NavWidthChanger = require('balus/ui/view/nav-width-changer');
const DataContentSelectorView = require('balus/ui/view/modal/data-content-selector');
const Router = require('balus/app/router/index');
const ImportDiagramSelectorView = require('balus/ui/view/body/diagram/modal/import-diagram-selector');
const Template = require('balus/ui/template/body/diagram/nav/index.hbs');

module.exports = Mn.View.extend({
    editMode: false,
    template: Template,
    regions: {
        diagramList: '.diagram-list-wrapper',
        widthChanger: '#nav-width-changer-wrapper',
        importFileSelector: '.import-file-selector',
        importDiagramSelector: '.import-diagram-selector'
    },
    ui: {
        editButton: '.nav-edit',
        doneButton: '.nav-done',
        diagramAddButton: '.diagram-add-button',
        diagramDirectoryAddButton: '.diagram-directory-add-button',
        importButton: '.nav-import'
    },
    events: {
        'click @ui.editButton': 'startEditMode',
        'click @ui.doneButton': 'endEditMode',
        'click @ui.diagramAddButton': 'addDiagram',
        'click @ui.diagramDirectoryAddButton': 'addDiagramDirectory',
        'click @ui.importButton': 'showImportAction'
    },

    templateContext: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        const group = context.getGroup();
        return {
            isMember: group.isMember(user ? user.id : null),
            isEditMode: this.getOption('editMode'),
            isImportable: group.isMember(user ? user.id : null)
        };
    },

    onRender: function() {
        const groupId = this.model.getGroupId();
        GroupAction.fetchGroupOnce(groupId).then(() => {
            const group = GroupRepository.getGroups().get(groupId);
            DiagramAction.fetchDiagramsOnce(this.model.id);
            DiagramAction.fetchDirectoriesOnce(this.model.id);

            this.showChildView('diagramList', new DiagramListView({
                group: group,
                model: this.model,
                diagram: this.getOption('diagram'),
                context: {
                    projectId: this.model.id
                },
                collection: DiagramRepository.getDiagrams({
                    context: {
                        projectId: this.model.id
                    }
                }),
                editMode: this.getOption('editMode'),
                showDescription: true
            }));
        });
        this.showChildView('widthChanger', new NavWidthChanger());
        this.showChildView('importFileSelector', new DataContentSelectorView({
            project: this.model,
            hideURLInput: true,
            accept: ['xmi'],
            title: i18n.t('balus_template_body_diagram:nav.import')
        }));
        this.listenTo(this.getChildView('importFileSelector'), 'select', function(content) {
            this.importAction(content);
        });
    },

    startEditMode: function() {
        this.editMode = true;
        this.render();
    },

    endEditMode: function() {
        this.editMode = false;
        this.render();
    },

    addDiagram: function() {
        const d = new DiagramModel({
            project_id: this.model.id,
            group_id: this.getOption('context').getGroup().id,
            edit: true,
            creating: true
        });
        const modal = new ModalView({
            title: i18n.t('base:title.diagram.create'),
            bodyView: new DiagramEditView({
                model: d,
                project: this.model
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    },

    addDiagramDirectory: function() {
        const d = new Backbone.Model({
            name: null,
            directory: true,
            diagrams: [],
            project_id: this.model.id,
            group_id: this.model.get('group_id'),
            open: true,
            edit: true,
            creating: true
        });

        const modal = new ModalView({
            title: i18n.t('system_template_modal:add-diagram-directory.title'),
            saveButtonEnable: true,
            bodyView: new DiagramDirectoryEditView({
                model: d,
                context: {
                    projectId: this.model.id
                }
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    },

    showImportAction: function() {
        this.getChildView('importFileSelector').show();
    },

    importAction: function(content) {
        (new ImportableDiagramListService(
            this.getOption('context').getProject(),
            content.getLatestVersion()
        ))
            .execute()
            .then(diagramList => {
                this.showImportDiagramSelector(diagramList, content);

                this.getChildView('importFileSelector').hide();
            });
    },

    showImportDiagramSelector: function(diagramList, content) {
        this.showChildView('importDiagramSelector', new ImportDiagramSelectorView());
        this.getChildView('importDiagramSelector').show(diagramList);
        this.listenTo(this.getChildView('importDiagramSelector'), 'select', function(xmiID) {
            (new ImportableDiagramService(
                this.getOption('context').getProject(),
                content.getLatestVersion(),
                xmiID
            )).execute()
                .then(importRequestKey => {
                    const key = new Key(importRequestKey);
                    Router.navigateDiagramImport(this.model, key.parent.id, key.id);

                    this.getChildView('importDiagramSelector').hide();
                });
        });
    },
});




// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/nav/index.js